/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_SrealityInputs */

const cs_enum_sreality = /** @type {(inputs: Enum_SrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

const en_enum_sreality = /** @type {(inputs: Enum_SrealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

/**
* | output |
* | --- |
* | "Sreality" |
*
* @param {Enum_SrealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_sreality = /** @type {((inputs?: Enum_SrealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_SrealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_sreality(inputs)
	return cs_enum_sreality(inputs)
});